'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var Autocomplete = _interopDefault(require('@material-ui/lab/Autocomplete'));
var KeyboardArrowDownIcon = _interopDefault(require('@material-ui/icons/KeyboardArrowDown'));
var styledComponents = require('./styled-components.js');

var InputSelect = function (props) {
    var _a = props.disableClearable, disableClearable = _a === void 0 ? false : _a, _b = props.disabled, disabledInput = _b === void 0 ? false : _b, id = props.id, reporter = props.reporter, _c = props.options, options = _c === void 0 ? [] : _c, _d = props.placeholder, placeholder = _d === void 0 ? '' : _d, _e = props.defaultValue, defaultValue = _e === void 0 ? null : _e;
    var _f = React.useState(defaultValue), selected = _f[0], setSelected = _f[1];
    var onChange = function (event, value) {
        setSelected(value);
        reporter(value, event);
    };
    var renderInput = function (params) { return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React__default.createElement(styledComponents.StyledTextField, tslib.__assign({}, params, { placeholder: placeholder, variant: 'outlined' }))); };
    return (React__default.createElement(Autocomplete, { id: id, options: options, onChange: onChange, disabled: disabledInput, value: selected, disableClearable: disableClearable, getOptionSelected: function (option, value) { return option.display === value.display; }, popupIcon: React__default.createElement(KeyboardArrowDownIcon, { "data-testid": 'autocomplete-icon' }), getOptionLabel: function (option) { return option.display; }, renderInput: renderInput }));
};

module.exports = InputSelect;
